"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnClickApple = void 0;
const utils_1 = require("../../utils");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("../..");
function braintreeOnClickApple() {
    const appleInstance = (0, src_1.getBraintreeApplePayInstanceChecked)();
    const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
    const { order_total } = (0, checkout_frontend_library_1.getApplicationState)();
    const { general_settings: { checkout_process: { phone_number_required: isPhoneRequired } } } = (0, checkout_frontend_library_1.getOrderInitialData)();
    const displayItems = (0, utils_1.getPaymentRequestDisplayItems)().map(({ label, amount }) => ({
        label,
        amount: (0, utils_1.getValueByCurrency)(amount, currencyCode),
    }));
    const fields = ['postalAddress', 'email'];
    const fieldsWithPhone = [...fields, 'phone'];
    const paymentRequest = appleInstance.createPaymentRequest({
        currencyCode: currencyCode,
        total: { label: 'Total', amount: (0, utils_1.getValueByCurrency)(order_total, currencyCode) },
        lineItems: displayItems,
        requiredBillingContactFields: isPhoneRequired ? fieldsWithPhone : fields,
        requiredShippingContactFields: isPhoneRequired ? fieldsWithPhone : fields,
    });
    const applePaySession = new ApplePaySession(src_1.braintreeConstants.APPLEPAY_VERSION_NUMBER, paymentRequest);
    applePaySession.onvalidatemerchant = src_1.braintreeOnValidateMerchantApple;
    applePaySession.onshippingcontactselected = src_1.braintreeOnShippingContactSelectedApple;
    applePaySession.onshippingmethodselected = src_1.braintreeOnShippingMethodSelectedApple;
    applePaySession.onpaymentauthorized = src_1.braintreeOnPaymentAuthorizedApple;
    applePaySession.begin();
    (0, src_1.setBraintreeApplePaySession)(applePaySession);
}
exports.braintreeOnClickApple = braintreeOnClickApple;
